
import { computed, defineComponent, onMounted, reactive } from 'vue'

// types
import { CostFileT, GetCostFilesT, UploadedFileT } from '@/core/types/create_order.types'

// module components
import UploadedFile from '@/modules/InvoiceModule/components/UploadedFile/index.vue'
import { orders } from '@/core/realisations/orders.realisation'

export default defineComponent({
    components: {
        UploadedFile,
    },
    props: {
        title: {
            type: String,
            default: 'Title',
        },
        invoiceId: {
            type: Number,
            default: null,
        },
        orderId: {
            type: Number,
            default: null,
        },
    },
    setup(props) {
        const state = reactive({
            is_visible: false,
            is_loading: false,
            //
            checks_road: [] as UploadedFileT[],
            cost_road: null as number | null,
            //
            checks_parking: [] as UploadedFileT[],
            cost_parking: null as number | null,
        })

        const toggleCostFiles = () => {
            state.is_visible = !state.is_visible
        }

        const editFiles = (files: CostFileT[]) => {
            return files.map((file) => {
                return {
                    id: file.id,
                    path: file.url,
                    original_name: file.originalName,
                    userEmail: file.userEmail,
                }
            })
        }

        const setChecks = (response: GetCostFilesT) => {
            if (response.data) {
                const data = response.data

                const checks_parking = data.find((check) => check.type === 2)
                if (checks_parking) {
                    state.checks_parking = editFiles(checks_parking.files)
                    state.cost_parking = checks_parking.cost
                }

                const checks_road = data.find((check) => check.type === 1)
                if (checks_road) {
                    state.checks_road = editFiles(checks_road.files)
                    state.cost_road = checks_road.cost
                }
            }
        }

        const loadCostFiles = async () => {
            if (!props.invoiceId && !props.orderId) return

            try {
                state.is_loading = true

                let response = null
                if (props.invoiceId) {
                    response = await orders.getCostFilesDeliveries(props.invoiceId)
                } else if (props.orderId) {
                    response = await orders.getCostFilesTakes(props.orderId)
                }

                if (response) {
                    setChecks(response)
                }
            } catch (error) {
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        //

        const isParkingFiles = computed(() => {
            return Boolean(state.checks_parking.length)
        })
        const isRoadFiles = computed(() => {
            return Boolean(state.checks_road.length)
        })
        const getClass = computed(() => {
            return `fas fa-angle-down CostFiles__icon ${
                state.is_visible ? 'CostFiles__icon-rotate' : ''
            }`
        })
        const userEmail = computed(() => {
            if (isParkingFiles.value) {
                return state.checks_parking[0].userEmail
            }
            if (isRoadFiles.value) {
                return state.checks_road[0].userEmail
            }

            return '-'
        })

        //

        onMounted(loadCostFiles)

        //

        return {
            state,
            //
            toggleCostFiles,
            //
            isParkingFiles,
            isRoadFiles,
            getClass,
            userEmail,
        }
    },
})
